module.controller(
    'productDetailCtrl',
    [ '$scope', '$rootScope', '$state', 'productService', 'alertService', 
        function($scope, $rootScope, $state, productService, alertService) {

    		$scope.validation = {name: {maxlength:255},regulationNumber: {maxlength:255},issuingCompany: {maxlength:255}};
            $scope.operationType = $state.current.data.type;
            $scope.idProduct = $state.params.id;
            $scope.product = {
            	category: {}
            };
            $scope.loading = false;

            /**
             *
             * @param idUser
             */
            $scope.load = function(idProduct) {
                $scope.loading = true;

                productService.loadProduct(idProduct).then(function(response) {
                    $scope.loading = false;

                    var responseData = response.getData();
                    $scope.product = {
                      name : responseData.name,                     
                      category: {
                    	  selected: [{
                    		  id: responseData.category.id,
                    		  name: responseData.category.name,
                    		  value: responseData.category.value
                    		 }]
                      }
                    };
                }, function(response) {
                    $scope.loading = false;
                });
            };

            /**
             *
             */
            $scope.sendAction = function() {
                if ($scope.operationType == 'create') {
                    $scope.create();
                } else {
                    $scope.update();
                }
            };

            /**
             *
             */
            $scope.create = function() {
                alertService.showSwtQuestion('Crear Producto', function() {
                    $scope.loading = true;

                    var createModel = {
                    	name: $scope.product.name,                    	
                    	idCategory: $scope.product.category.selected[0].id
                    };

                    productService.createProduct(createModel).then(function(response) {
                        $scope.loading = false;
                        alertService.showSuccess('Producto creado satisfactoriamente');
                        $state.go('home.productList');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };

            /**
             *
             */
            $scope.update = function() {
                alertService.showSwtQuestion('Actualizar producto', function() {
                    $scope.loading = true;

                    var updateModel = {
                        	name: $scope.product.name,                    	
                        	idCategory: $scope.product.category.selected[0].id
                        };
                    
                    productService.updateProduct($scope.idProduct, updateModel).then(function(response) {
                        $scope.loading = false;
                        alertService.showSuccess('Producto actualizada satisfactoriamente');
                        $state.go('home.productList');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };


            if ($scope.operationType == 'update') {
                $scope.load($state.params.id);
            }

        } ]);


